module.exports = __webpack_public_path__ + "img/austria-tuberculosis-female.93e6548e.png";